import { styled } from "styled-components";
import { Colors } from "../../styles/Colors";
export const Divider = styled.hr `
  height: 1px;
  margin: 0.5rem 0;
  color: inherit;
  background-color: ${Colors.GRAY_DARK};
  border: 0;
  opacity: 0.25;
`;
Divider.displayName = "Divider";
export default Divider;
//# sourceMappingURL=index.js.map